<template>
  <div class="reset">
    <div class="container">
      <!--      <img class="got-mold-box" src="../images/bg/bg_box.png" alt="Box" />-->
      <div class="form">
        <div class="title">
          Forgot Password
        </div>
        <div class="input-wrap">
          <input
            type="text"
            class="input toLowerCase"
            placeholder="Email"
            name="emailForget"
            v-model="email"
            v-validate="'required|max:50|email'"
            :class="{ invalid: errors.has('email') }"
            :disabled="sended"
          />
          <span class="validate-error" v-if="errors.has('emailForget')">
            {{ errors.first("emailForget") }}
          </span>
          <span v-if="failed && !errors.has('emailForget')" class="validate-error">Invalid email, please try again.</span>
        </div>
        <button
          class="btn"
          @click.prevent="$validator.validateAll()"
          @click="resetpass"
          :class="{ hide: sended }"
          :disabled="!this.email"
        >
          Send
        </button>
        <span v-if="sended" class="success-msg">Reset password link is sent, please check your email.</span>
        <router-link
          tag="button"
          to="/login"
          class="back-btn"
          :class="{ greenbg: sended }"
          >Go back</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
import { ErrorBag } from "vee-validate";
export default {
  name: "Resetpassword",
  data() {
    return {
      email: "",
      sended: false,
      failed: false
    };
  },
  methods: {
    ...mapActions(["resetPassword"]),
    ...mapMutations(["clearServerValidationErrors"]),
    resetpass() {
      this.failed = false;
      if (this.errors.any() || !this.isComplete) {
        return;
      }
      const data = {
        email: this.email
      };
      this.resetPassword(data).then(res => {
        this.errors.clear();
        this.clearServerValidationErrors();
        this.sended = true;
      }).catch(err => {
        this.errors.clear();
        this.clearServerValidationErrors();
        this.failed = true;
      });
    }
  },
  computed: {
    isComplete() {
      return this.email;
    },
    ...mapGetters(["serverValidation"])
  },
  watch: {
    serverValidation(error) {
      error.forEach(item => {
        this.$validator.errors.add({ field: item.field, msg: item.message });
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import "../styles/_colors.scss";
.reset {
  max-width: 100%;
  width: 100vw;
  height: auto;
  min-height: calc(100vh - 60px);
  display: flex;
  background-color: transparent;
  padding: 100px 0 0 0;
}
.form {
  padding: 36px 80px 40px 80px;
  background-color: $white;
  max-width: 500px;
  width: 50%;
  margin: 40px 0 0 auto;
  box-shadow: 0 3px 15px -9px $boxShadow;
  position: relative;
  border-radius: 15px;
  font-family: TTNormsMedium, sans-serif;
}
.title {
  color: $blue;
  font-family: TTNormsBold, sans-serif;
  font-size: 27px;
  text-align: center;
  margin: 0 0 36px 0;
}

.input {
  padding: 17px 20px;
  border-radius: 10px;
  color: $gray;
  width: 100%;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
  text-align: center;
  border: 1px solid #c5c5c5;
  outline: none;
}
.input:focus {
  border: 1px solid rgb(77, 144, 254);
}
.input.invalid:focus {
  border: 1px solid rgb(77, 144, 254);
}
.input::placeholder {
  color: $lightGray;
  font-size: 16px;
}
.input:disabled {
  border: none;
  color: #333;
  -webkit-text-fill-color: #333;
}
.btn {
  background-color: $green;
  width: 50%;
  margin: 36px auto 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $white;
  cursor: pointer;
  outline: none;
  border: 1px solid transparent;
  height: 45px;
  border-radius: 25px;
  font-size: 18px;
  transition: all 0.5s linear;
  font-family: TTNormsBold, sans-serif;
}
.btn.hide {
  display: none;
}
.btn:disabled {
  cursor: default;
  opacity: 0.5;
}
.back-btn {
  color: $green;
  border: none;
  cursor: pointer;
  outline: none;
  display: block;
  margin: 36px auto 0 auto;
  background-color: transparent;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
}
.back-btn.greenbg {
  background-color: $green;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $white;
  cursor: pointer;
  outline: none;
  border: 1px solid transparent;
  height: 45px;
  border-radius: 25px;
  margin: 20px 0 20px 0;
  font-size: 18px;
  transition: all 0.5s linear;
  font-family: TTNormsMedium, sans-serif;
}
@media screen and (max-width: 1000px) {
  .form {
    padding: 30px;
    max-width: 450px;
  }
  .got-mold-box {
    bottom: 200px;
  }
}
@media screen and (max-width: 768px) {
  .reset {
    background: url("../images/bg/sky-mobile.jpg");
    padding: 90px 0 0 0;
  }
  .form {
    margin: 0 auto;
    width: 100%;
  }
}
@media (max-width: 568px) {
  .form {
    padding: 36px 20px 40px 20px;
    max-width: 100%;
  }
}
.success-msg {
  font-size: 14px;
  color: green;
}
.failed-msg {
  font-size: 14px;
  color: #ca3232;
}
</style>
